import { render, staticRenderFns } from "./TestInfo.vue?vue&type=template&id=0ae0ee06&scoped=true"
import script from "./TestInfo.vue?vue&type=script&lang=js"
export * from "./TestInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae0ee06",
  null
  
)

export default component.exports